import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  Button,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useNavigate } from 'react-router-dom';

import { dummyFeatures, dummyPackages } from '../../data/packages';
import { getFeatureNameById } from '../../utilities/package';

const PackagesSection = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h4" align="center" fontWeight="bold" gutterBottom>
        Registration Packages
      </Typography>
      <Typography
        variant="body1"
        align="center"
        sx={{ mb: 6 }}
        color="textSecondary"
      >
        Launch your company with confidence. Our packages make it easy to
        establish the right business structure, whether you're starting small,
        building a non-profit, or expanding globally.
      </Typography>
      <Grid container spacing={4}>
        {dummyPackages.map((plan, i) => (
          <Grid item xs={12} sm={6} md={4} lg={plan.highlight ? 4 : 3} key={i}>
            <Card
              elevation={plan.highlight ? 10 : 2}
              sx={{
                borderRadius: 4,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
              }}
            >
              {plan.badge && (
                <Chip
                  label={plan.badge}
                  color="info"
                  sx={{ position: 'absolute', top: 16, right: 16, zIndex: 1 }}
                />
              )}

              <Box
                sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}
              >
                <CardHeader
                  title={plan.name}
                  titleTypographyProps={{ variant: 'h6' }}
                  subheader={`£${plan.price}`}
                  subheaderTypographyProps={{ variant: 'h4', color: 'primary' }}
                ></CardHeader>
                <CardContent sx={{ pt: 0, flexGrow: 1 }}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    {plan.note}
                  </Typography>
                  <List dense>
                    {plan.features.map((feat, idx) => (
                      <ListItem key={idx}>
                        <ListItemIcon>
                          <CheckIcon color="success" fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                          primary={getFeatureNameById(feat, dummyFeatures)}
                          primaryTypographyProps={{ fontSize: 14 }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Box>

              <Box sx={{ p: 2, mt: 'auto' }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => navigate(`/register/${plan.id}`)}
                >
                  Choose Plan
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default PackagesSection;
